import { NODE_ABI, SALE_ABI, TIER_PRICE_ABI } from '@lfg/abis';
import { Interface } from 'ethers';
import RLP from 'rlp';
import { Address, keccak256 } from 'viem';

import { Phase } from 'src/global/types/project.type';

const makeAddress = (contractAddress: string, nonce: number): Address => {
  const addressHash = keccak256(RLP.encode([contractAddress, nonce]));
  return `0x${addressHash.slice(26)}`;
};

const encodeSaleWithSelector = (
  startSale: number,
  phases: Array<Phase>,
  payments: Array<Address>,
  rewardsPercent: number,
  enableRedeem: boolean,
) => {
  const outputPhases = phases.reduce((acc: Array<Phase>, current: Phase, index) => {
    acc.push({
      totalNode: (acc[index - 1]?.totalNode || 0) + current.totalNode,
      recipients: current.recipients,
    });
    return acc;
  }, []);
  const abi = new Interface(SALE_ABI);

  const encodedData = abi.encodeFunctionData('initialize', [
    payments,
    startSale,
    outputPhases.map(phase => [
      phase.recipients.map(recipient => recipient.address),
      phase.recipients.map(recipient => recipient.percent * 100),
      phase.totalNode,
    ]),
    rewardsPercent,
    enableRedeem,
  ]);
  return encodedData;
};

const encodeTierPriceWithSelector = (
  border: Array<number>,
  price: Array<number>,
  increaseAmount: number,
  increasePrice: number,
  cap: number,
  priceCap: number,
) => {
  const outputBorder = border.reduce((acc: Array<number>, current, index) => {
    acc.push((acc[index - 1] || 0) + current);
    return acc;
  }, []);
  const abi = TIER_PRICE_ABI;
  const tierInterface = new Interface(abi);
  const encodedData = tierInterface.encodeFunctionData('initialize', [
    outputBorder,
    price,
    increaseAmount,
    increasePrice,
    cap,
    priceCap,
  ]);
  return encodedData;
};

const encodeNodeData = (
  name: string,
  symbol: string,
  website: string,
  baseUri: string,
  unlockTransferTime: number,
  _royaltyFee: number,
) => {
  const nodeInterface = new Interface(NODE_ABI);
  const encodedData = nodeInterface.encodeFunctionData('initialize', [
    name,
    symbol,
    website,
    baseUri,
    unlockTransferTime,
  ]);
  return encodedData;
};

export { makeAddress, encodeSaleWithSelector, encodeTierPriceWithSelector, encodeNodeData };
